/** One symbol out of the inlined sprite. Stroke and grid come from the registry. */
export function Icon({ name, className = '' }: { name: string; className?: string }) {
  return (
    <svg className={`i ${className}`.trim()} aria-hidden="true">
      <use href={`#pv-${name}`} />
    </svg>
  );
}
